<div class="container-fluid p-4">
    <!-- <app-loader *ngIf="loading" [fullPage]="true" [message]="'Loading analytics data...'" [size]="'large'"></app-loader> -->

    <!-- <div class="content" [ngClass]="{'loading-content': loading}"> -->
    <div class="content" [ngClass]="{'loading-content': hasAnyLoadingState()}">
        <!-- Filters Section -->
        <div class="row mb-4">
            <div class="col-12">
                <app-data-filters 
                    [autoLoadFilters]="false"
                    [showJournalFilter]="true"
                    [showRegionFilter]="true"                    
                    [showInstitutionFilter]="false"
                    (filtersChanged)="onFiltersChanged($event)">
                </app-data-filters>
            </div>
        </div>
        <!-- Charts Section -->
        <div class="row g-4">
            <div *ngIf="isPool()">
                <!-- Active Authors -->
                <div class="col-12">
                    <div class="chart-container">
                        <!-- Using the new loading property on the chart component -->
                        <app-line-area-chart 
                          [title]="'Active Authors'" 
                          [data]="activeAuthorsData"
                          [series]="activeAuthorsSeries" 
                          [legendInfo]="activeAuthorsLegendInfo"
                          [fileName]="'active-authors.png'" 
                          [defaultType]="'line'" 
                          [lineOnly]="false"
                          [showToggle]="true" 
                          height="400px" 
                          [loading]="loadingStates['activeAuthors']"
                          [powerBiUrl]="'https://app.powerbi.com/groups/61126d5e-27e3-41d9-9f04-32d95e58b74c/list?experience=power-bi'">
                        </app-line-area-chart>
                    </div>
                </div>

                <!-- Authors Pool Progression -->
                <div class="col-12">
                    <div class="chart-container position-relative">
                        <!-- <app-horizontal-target-line [position]="targetLinePosition" [label]="''"
                            (lineClicked)="onTargetLineClick()">
                        </app-horizontal-target-line> -->

                        <!-- Using the new loading property on the chart component -->
                        <app-line-area-chart 
                          [title]="'Author Pool Progression'" 
                          [data]="poolProgressionData"
                          [series]="poolProgressionSeries" 
                          [legendInfo]="poolProgressionLegendInfo"
                          [fileName]="'author-pool-progression.png'" 
                          [showToggle]="true" 
                          [lineOnly]="false"
                          height="400px" 
                          [loading]="loadingStates['poolProgression']"
                          [powerBiUrl]="'https://app.powerbi.com/groups/61126d5e-27e3-41d9-9f04-32d95e58b74c/list?experience=power-bi'">
                        </app-line-area-chart>
                    </div>
                </div>

                <!-- Author Retention Rate-->
                <div class="col-12">
                    <div class="chart-container">
                        <!-- Using the new loading property on the chart component -->
                        <app-line-area-chart 
                          [title]="'Author Retention Rate %'" 
                          [data]="transfersRetentionData"
                          [series]="transfersRetentionSeries" 
                          [legendInfo]="transfersLegendInfo"
                          [fileName]="'author-transfers-retention.png'" 
                          [defaultType]="'line'" 
                          [lineOnly]="false"
                          [showToggle]="true" 
                          height="400px"
                          [loading]="loadingStates['transfersRetention']"
                          [powerBiUrl]="'https://app.powerbi.com/groups/61126d5e-27e3-41d9-9f04-32d95e58b74c/list?experience=power-bi'">
                        </app-line-area-chart>
                    </div>
                </div>

            </div>
            <!-- Author Submissions Stats Numbers -->
            <div *ngIf="isSubmissions()">

                <!-- 5 Year Average Articles -->
                <!-- Removing the submitted-published chart section -->
                <div class="col-12">
                    <div class="chart-container">
                        <!-- Using the new loading property on the chart component -->
                        <app-line-area-chart 
                          [title]="'Number of Authors submitting and publishing articles'"
                          [data]="submittedPublishedDataAvg" 
                          [series]="AvgSubmittedPublishedSeries"
                          [legendInfo]="submittedPublishedAvgLegendInfo" 
                          [fileName]="'average-articles.png'"
                          [showToggle]="true" 
                          [lineOnly]="false" 
                          height="400px"
                          [loading]="loadingStates['submittedPublishedAvg']"
                          [powerBiUrl]="'https://app.powerbi.com/groups/61126d5e-27e3-41d9-9f04-32d95e58b74c/list?experience=power-bi'">
                        </app-line-area-chart>
                    </div>
                </div>

                <div class="col-12">
                    <div class="chart-container">
                        <!-- Using the new loading property on the chart component -->
                        <app-line-area-chart 
                          [title]="'Author Contribution'" 
                          [data]="submissionsCountData" 
                          [series]="submissionsCountSeries"
                          [legendInfo]="submissionsCountLegendInfo" 
                          [fileName]="'submissions-count.png'"
                          [defaultType]="'line'" 
                          [showToggle]="false" 
                          [lineOnly]="true"                             
                          height="400px"
                          [isStackedBarChart]="true"
                          [loading]="loadingStates['submissionsCount']"
                          [powerBiUrl]="'https://app.powerbi.com/groups/61126d5e-27e3-41d9-9f04-32d95e58b74c/list?experience=power-bi'">
                        </app-line-area-chart>
                    </div>
                </div>

                
                <!-- Author Submissions Stats Chart -->
                <div class="col-12">
                    <div class="chart-container">
                        <!-- Using the new loading property on the chart component -->
                        <app-line-area-chart 
                          [title]="'% of Authors with more than 2, 5, and 10 submissions'"
                          [data]="submissionsStatsData" 
                          [series]="submissionsStatsSeries"
                          [legendInfo]="submissionsLegendInfo" 
                          [fileName]="'submissions-stats.png'"
                          [defaultType]="'bar'" 
                          [showToggle]="true" 
                          [lineOnly]="false" 
                          height="400px"
                          [isStackedBarChart]="false"
                          [loading]="loadingStates['submissionsStats']"
                          [powerBiUrl]="'https://app.powerbi.com/groups/61126d5e-27e3-41d9-9f04-32d95e58b74c/list?experience=power-bi'">
                        </app-line-area-chart>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
